import Intro from "../../components/tilsynserklaering/Intro";
import TilsynserklaeringForm from "../../components/tilsynserklaering/TilsynerklaeringForm";
import { TILSYN_META_DATA } from "../../constants/metaData";
import { TILSYN_FORM_INITIAL_VALUES } from "../../constants/tilsyn/initialValues";

export default function TilsynsErklaeringDesign() {
  return (
    <>
      <Intro />
      <TilsynserklaeringForm
        id={"#"}
        initialValues={TILSYN_FORM_INITIAL_VALUES}
        metaData={TILSYN_META_DATA}
        loginToken="/link/til/tilsynserklaering"
      />
    </>
  );
}
